import React, { useMemo } from 'react'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { useSeDebug } from './SeDebugContext'

function SeDebugControl () {
  const { isSummitUser } = useAppContext()
  const debug = useSeDebug()
  const prodSuffix = debug?.prodSuffix
  const devSuffix = debug?.devSuffix

  const options = useMemo(() => {
    if (!prodSuffix || !devSuffix) return []
    const entries = [
      { label: prodSuffix, value: prodSuffix },
      { label: devSuffix, value: devSuffix }
    ]
    const seen = new Set()
    return entries.filter(e => {
      if (seen.has(e.value)) return false
      seen.add(e.value)
      return true
    })
  }, [prodSuffix, devSuffix])

  if (!isSummitUser || !debug || !debug.showDebugControl || options.length < 2) return null

  return (
    <select
      value={debug.suffix}
      onChange={(e) => debug.setSuffix(e.target.value)}
      style={{
        fontSize: 'var(--font-size-xs)',
        padding: '2px 4px',
        borderRadius: '4px',
        border: '1px solid var(--color-neutral-300)',
        backgroundColor: 'var(--color-neutral-100)',
        color: 'var(--text-color-subtle)',
        cursor: 'pointer',
        maxWidth: '200px'
      }}
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  )
}

export default SeDebugControl
